import React from "react"
import { Link } from "react-router-dom"

function NotFound() {
  return (
    <div
      className="uk-flex uk-flex-center uk-flex-column uk-flex-middle"
      uk-height-viewport="offset-bottom: 20"
    >
      <span className="uk-text-bold uk-margin-remove" style={{ fontSize: 120 }}>
        404
      </span>
      <span
        className="uk-text-bold uk-margin-small-bottom"
        style={{ fontSize: 32 }}
      >
        We couldn't find the page.
      </span>
      <span>
        Sorry, but the page you are looking for was either not found or does not
        exist.
      </span>
      <span>
        Try refreshing the page or go back to the <Link to="/">Homepage</Link>
      </span>
    </div>
  )
}

export default NotFound
